import React from 'react';
// import { Link } from 'react-router-dom';
import classNames from 'classnames';

const Sidebar = ({ children, hidden }) => {
  const cx = classNames("sidebar", {"is-hidden": hidden})

  return (
    <div className={cx}>
      { children }
    </div>
  )
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/sidebar/index.js